var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useEffect, useMemo, useRef } from "react";
export var useSearchActionsWithUpdateFilters = function (criteria, searchActions, updateFilters, refreshAllFilters, rehydrateFilterLookups) {
    var filter = useRef([]);
    var updateCriteriaHandler = searchActions.updateCriteria;
    var updateCriteria = useCallback(function (criteria, options, filterId) {
        var _a;
        if (Array.isArray(filterId)) {
            (_a = filter.current).push.apply(_a, filterId);
        }
        else if (filterId) {
            filter.current.push(filterId);
        }
        updateCriteriaHandler(criteria, options, filterId);
        if (options === null || options === void 0 ? void 0 : options.hydrateLookups) {
            rehydrateFilterLookups(criteria, { merge: true });
        }
    }, [updateCriteriaHandler, rehydrateFilterLookups]);
    useEffect(function () {
        if (filter.current.length) {
            updateFilters(filter.current, criteria);
            filter.current = [];
        }
    }, [criteria, updateFilters]);
    return useMemo(function () {
        var setCriteriaHandler = searchActions.setCriteria, actions = __rest(searchActions, ["setCriteria"]);
        var setCriteria = function (criteria, options) {
            setCriteriaHandler(criteria, options);
            var cr = criteria.criteria;
            refreshAllFilters(cr);
            if (cr) {
                rehydrateFilterLookups(cr);
            }
        };
        return __assign(__assign({}, actions), { setCriteria: setCriteria, updateCriteria: updateCriteria });
    }, [searchActions, refreshAllFilters, rehydrateFilterLookups, updateCriteria]);
};
//# sourceMappingURL=use-search-actions-with-update-filters.js.map